import { render } from "./EventsComponent.vue?vue&type=template&id=7648c03b&scoped=true"
import script from "./EventsComponent.vue?vue&type=script&lang=js"
export * from "./EventsComponent.vue?vue&type=script&lang=js"

import "./EventsComponent.vue?vue&type=style&index=0&id=7648c03b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7648c03b"]])

export default __exports__